import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=checking, false=not auth, obj=auth
  useEffect(() => {
    if (!window.location.pathname.startsWith("/admin")) { setAdmin(false); return; }
    api.get("/auth/me").then((r) => setAdmin(r.data)).catch(() => setAdmin(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAdmin(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("logout failed", e); }
    setAdmin(false);
  };
  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
};
